import { render, staticRenderFns } from "./noAccess.vue?vue&type=template&id=6b21da23&scoped=true"
import script from "./noAccess.vue?vue&type=script&lang=js"
export * from "./noAccess.vue?vue&type=script&lang=js"
import style0 from "./noAccess.vue?vue&type=style&index=0&id=6b21da23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b21da23",
  null
  
)

export default component.exports